var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 250,
    viewBox: "0 0 357 250",
    fill: "#4F46E5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_1532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.946 0V10.7361C239.391 26.3184 161.477 64.0653 83.0806 155.412V28.9975C83.0806 12.9636 96.0713 0 112.082 0H291.946Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.946 56.9614V190.33H145.416C143.44 190.33 141.524 190.611 139.749 191.142C176.363 149.803 230.182 96.113 291.946 56.9614Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.416 230.444H291.946V250H112.082C105.962 250 100.305 248.114 95.6299 244.873C101.629 236.896 111.861 223.702 125.584 207.527C125.413 208.46 125.363 209.414 125.363 210.377C125.363 215.926 127.62 220.942 131.252 224.555C134.853 228.187 139.869 230.444 145.416 230.444Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.946 199.189H148.646V207.648H291.946V199.189Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.946 213.869H148.646V222.327H291.946V213.869Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 139.439L80.2518 246.709C80.2518 246.709 205.505 68.9216 357 11.1575C357 11.1575 218.997 5.90989 81.0041 175.44C81.0041 175.45 50.2577 133.438 0 139.439Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_1532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 357,
    height: 250,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cede6d30d6f5dda414dd3eab299e4e1d.svg";
export { ForwardRef as ReactComponent };